export default {"src":"/_next/static/media/Psoriasis.b93ecbe1.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};